<template>
  <div class="sample-reviews">
    <h3 class="mt-0">{{ $t("ratingForm.sampleReviews.label") }}</h3>
    <div class="box">
      <p v-html="$t('ratingForm.sampleReviews.r1')"></p>
    </div>
    <div class="box">
      <p v-html="$t('ratingForm.sampleReviews.r2')"></p>
    </div>
    <div class="box">
      <p v-html="$t('ratingForm.sampleReviews.r3')"></p>
    </div>
    <div class="box">
      <p v-html="$t('ratingForm.sampleReviews.r4')"></p>
    </div>
    <div class="box">
      <p v-html="$t('ratingForm.sampleReviews.r5')"></p>
    </div>

    <collapse-transition>
      <div v-if="!collapsed">
        <div class="box">
          <p v-html="$t('ratingForm.sampleReviews.r6')"></p>
        </div>
        <div class="box">
          <p v-html="$t('ratingForm.sampleReviews.r7')"></p>
        </div>
        <div class="box">
          <p v-html="$t('ratingForm.sampleReviews.r8')"></p>
        </div>
        <div class="box">
          <p v-html="$t('ratingForm.sampleReviews.r9')"></p>
        </div>
        <div class="box">
          <p v-html="$t('ratingForm.sampleReviews.r10')"></p>
        </div>
      </div>
    </collapse-transition>

    <button tabindex="0"
      class="btn btn-secondary"
      @click.prevent="collapsed = !collapsed"
      v-if="collapsed"
    >
      {{ $t("ratingForm.sampleReviews.showMore") }}
    </button>
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition";

export default {
  components: {
    CollapseTransition,
  },
  data() {
    return {
      collapsed: true,
    };
  },
};
</script>
